import Plugin from 'src/plugin-system/plugin.class';
//import Swiper, { Scrollbar } from 'swiper';

import Swiper from 'swiper/bundle';

export default class AktuelleThemenSliderPlugin extends Plugin {
    init() {

        const swiper = new Swiper('.aktuelle-themen-slider-widget', {
            slidesPerView: 1,
            spaceBetween: 10,
            scrollbar: {
                el: '.swiper-scrollbar',
                hide: false,
                draggable: true,
                snapOnRelease: true
            },
            breakpoints: {
                568: {
                  slidesPerView: 2,
                  spaceBetween: 30
                },
                // 667: {
                //     slidesPerView: 3,
                //     spaceBetween: 30
                // },
                // 768: {
                //     slidesPerView: 3,
                //     spaceBetween: 30
                // },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 30
                },
                // 1100: {
                //     slidesPerView: 3,
                //     spaceBetween: 30
                // },
                // 1200: {
                //     slidesPerView: 3,
                //     spaceBetween: 30
                // },
                // 1500: {
                //     slidesPerView: 3,
                //     spaceBetween: 30
                // }
            },
            loop: false,
            centeredSlides: false
        });

        document.addEventListener('Viewport/hasChanged', () => {
            swiper.update();
        });

    }
}

// xxxs: 0,
// xxs: 320px,
// xs: 568px,
// sm: 667px,
// md: 768px,
// lg: 992px,
// xl: 1100px,
// xxl: 1200px,
// xxxl: 1500px